import PropTypes from 'prop-types';

export const giaSelectedPropTypes = PropTypes.shape({
  document_number: PropTypes.shape({
    value: PropTypes.string
  }),
  registration_code: PropTypes.shape({
    value: PropTypes.string
  }),
  valid: PropTypes.bool
});

export const giaSelectedDefaultProp = {
  document_number: {
    value: ''
  },
  registration_code: {
    value: ''
  },
  valid: false
};

export const giaBlurPropTypes = PropTypes.shape({
  document_number: PropTypes.bool,
  registration_code: PropTypes.bool
});
